import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";

const ForYouCategoryForm = ({ user }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [updatedUser, setUpdatedUser] = useState({
    name: user.name || "",
    categoryType: user.categoryType || "",
  });

  const [isEdited, setIsEdited] = useState(false);

  // Detect changes between initial user data and updated data
  useEffect(() => {
    const hasChanges = Object.keys(updatedUser).some(
      (key) => updatedUser[key] !== user[key]
    );
    setIsEdited(hasChanges);
  }, [updatedUser, user]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedUser({
      ...updatedUser,
      [name]: value,
    });
  };

  const onSave = async (e) => {
    e.preventDefault();
    if (!isEdited) {
      toast.info("No changes detected. Please update the category before saving.");
      return;
    }

    const payload = {
      name: updatedUser.name,
      categoryType: updatedUser.categoryType,
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/for-you-category/foryou-category/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(() => navigate("/for-you-category"), 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during save:", error);

      if (error.response) {
        toast.error(error.response.data?.message || "Failed to update the category.");
      } else if (error.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("Unexpected error occurred.");
      }
    }
  };

  return (
    <div style={styles.container}>
      <ToastContainer />
      <div style={styles.header}>
        <h2 style={styles.title}>Update Category</h2>
        <div style={styles.buttonContainer}>
          <button
            style={styles.editButton}
            onClick={onSave}
          >
            Save
          </button>
        </div>
      </div>
      <div style={styles.infoContainer}>
        <div style={styles.infoRow}>
          <span style={styles.span}>Name</span>
          <input
            type="text"
            name="name"
            className="form-control w-50"
            value={updatedUser.name}
            onChange={handleInputChange}
            style={styles.input}
          />
        </div>
        <div style={styles.infoRow}>
          <label style={styles.span}>Type</label>
            <select
              name="categoryType"
              className="form-select w-50"
              value={updatedUser.categoryType}
              onChange={handleInputChange}
            >
              <option value="Free">Free</option>
              <option value="Paid">Paid</option>
            </select>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "600px",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#fff",
    fontFamily: "Poppins",
  },
  header: {
    backgroundColor: "#064260",
    padding: "20px 35px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "8px 8px 0 0"
  },
  title: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 600,
  },
  infoContainer: {
    padding: "0",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 35px",
    borderBottom: "1px solid #eee",
    fontSize: "1em",
    alignItems: "center",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
  },
  editButton: {
    backgroundColor: "#27B99A",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
  input: {
    padding: "8px",
    width: "50%",
    fontSize: "14px"
  }
};

export default ForYouCategoryForm;
